module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/4-363956c9e2578ac910faf0d6188e5d2d.jpg";